import { events } from '@estee/elc-service-bus';
import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

export class AccountSidebarOverlayOpenedUseCase {
    private eventRepository: EventRepository;

    constructor() {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
    }

    public execute = async () => {
        const payload = {
            event_name: 'my account page',
            event_category: 'my account page',
            event_action: 'account overlay',
            event_label: 'open',
            site_type: 'event_based'
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.ACCOUNT_SIDEBAR_OVERLAY_OPENED,
            type: 'link',
            payload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
